import React from "react";

const ThirdPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_3-medal"
    width="72"
    height="72"
    className="medals third-place"
    viewBox="0 0 72 72"
    aria-label="bronze medal position">
    <defs />
    <g id="Group_9220" transform="translate(-3473.633 477.434)">
      <g id="Group_8996">
        <path
          id="Path_15207"
          d="M3501.483-454.073h16.311l18.839-23.361h-16.31z"
          className="cls-1"
        />
        <path
          id="Path_15208"
          d="M3525.879-477.434l-18.841 23.36h5.2l18.84-23.36"
          className="cls-2"
        />
      </g>
      <path
        id="Path_15209"
        d="M3518.273-459h-23.244v13.894h4.939v-8.954h18.3v8.954h4.939V-459z"
        className="cls-3-trophy3"
      />
      <circle
        id="Ellipse_1693"
        cx="20.414"
        cy="20.414"
        r="20.414"
        className="cls-3-trophy3"
        transform="translate(3488.707 -452.333)"
      />
      <g id="Group_8997">
        <path
          id="Path_15210"
          d="M3517.19-454.073h-16.31l-18.842-23.361h16.31z"
          className="cls-1"
        />
        <path
          id="Path_15211"
          d="M3492.795-477.434l18.841 23.36h-5.2l-18.841-23.36"
          className="cls-2"
        />
      </g>
      <circle
        id="Ellipse_1694"
        cx="15.698"
        cy="15.698"
        r="15.698"
        fill="#8f6d63"
        transform="translate(3493.422 -447.618)"
      />
      <g id="_3" className="cls-5">
        <g id="Group_9225" className="cls-5">
          <path
            id="Path_15248"
            d="M3506.77-434.5h1.728a2.441 2.441 0 0 0 1.831-.617 2.261 2.261 0 0 0 .595-1.641 2 2 0 0 0-.589-1.538 2.288 2.288 0 0 0-1.623-.55 2.4 2.4 0 0 0-1.562.511 1.635 1.635 0 0 0-.629 1.331h-3.245a4 4 0 0 1 .691-2.3 4.62 4.62 0 0 1 1.931-1.59 6.484 6.484 0 0 1 2.735-.572 6.116 6.116 0 0 1 4.066 1.241 4.232 4.232 0 0 1 1.471 3.419 3.441 3.441 0 0 1-.686 2.067 4.438 4.438 0 0 1-1.8 1.449 4.06 4.06 0 0 1 2.061 1.482 4.032 4.032 0 0 1 .679 2.336 4.3 4.3 0 0 1-1.589 3.492 6.385 6.385 0 0 1-4.206 1.315 6.061 6.061 0 0 1-4-1.291 4.22 4.22 0 0 1-1.556-3.414h3.246a1.878 1.878 0 0 0 .691 1.5 2.545 2.545 0 0 0 1.7.584 2.551 2.551 0 0 0 1.813-.612 2.11 2.11 0 0 0 .658-1.623q0-2.446-2.7-2.448h-1.717z"
            className="cls-3-trophy3"
          />
        </g>
      </g>
    </g>
    <path id="Rectangle_5642" fill="none" d="M0 0H72V72H0z" />
  </svg>
);

export default ThirdPlace;
